import * as React from 'react';
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';

import { cva, VariantProps } from 'class-variance-authority';
import { OmitStylesComponentProps } from '../../types';

import { toggleVariants } from '../toggle';
import { ToggleGroupContext } from './toggle-group';
import { cn } from '@rocco/utils/cn';

const ToggleGroupItemVariants = cva('', {
    variants: {
        shape: {
            default: 'rounded-full py-4 px-4',
        },
        width: {
            default: '',
            wide: 'w-40 text-base',
        },
        hover: {
            default: 'hover:bg-brick-200/50',
        },
        active: {
            default: 'data-[state=on]:bg-brick-200 data-[state=on]:text-black',
        },
    },
    defaultVariants: {
        shape: 'default',
        hover: 'default',
        active: 'default',
        width: 'default',
    },
});

export const ToggleGroupItem = React.forwardRef<
    React.ElementRef<typeof ToggleGroupPrimitive.Item>,
    OmitStylesComponentProps<typeof ToggleGroupPrimitive.Item> &
        VariantProps<typeof toggleVariants> &
        VariantProps<typeof ToggleGroupItemVariants>
>(({ children, variant, size, shape, hover, width, ...props }, ref) => {
    const context = React.useContext(ToggleGroupContext);
    const toggleitemClass = ToggleGroupItemVariants({
        shape,
        hover,
        width,
    });

    return (
        <ToggleGroupPrimitive.Item
            ref={ref}
            className={cn(
                toggleVariants({
                    variant: context.variant || variant,
                    size: context.size || size,
                }),
                toggleitemClass,
            )}
            {...props}
        >
            {children}
        </ToggleGroupPrimitive.Item>
    );
});

ToggleGroupItem.displayName = ToggleGroupPrimitive.Item.displayName;
